import { IconButton, Tooltip, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { Moon, Sun } from 'lucide-react';

export default function ColorModeToggle() {
  const { toggleColorMode } = useColorMode();
  const isDark = useColorModeValue(false, true);
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Tooltip label={label} openDelay={200}>
      <IconButton
        aria-label={label}
        onClick={toggleColorMode}
        variant="ghost"
        colorScheme="brand"
        icon={isDark ? <Sun size={22} /> : <Moon size={22} />}
      />
    </Tooltip>
  );
}
